/**
 * Gantt date-axis ruler — a full-width header showing the chart title in the
 * label gutter and date ticks (vertical guides + labels) across the timeline.
 */

import { memo } from 'react'
import { NodeProps } from '@xyflow/react'
import type { GanttAxis } from '../../types/schema'
import { GANTT_LABEL_W } from '../../utils/ganttLayout'

interface AxisData {
  label: string
  ganttAxis?: GanttAxis
}

function GanttAxisNode({ data, width, height }: NodeProps) {
  const nodeData = data as unknown as AxisData
  const ax = nodeData.ganttAxis
  const w = typeof width === 'number' ? width : 400
  const h = typeof height === 'number' ? height : 40
  const ticks = ax?.ticks ?? []
  const dayW = ax?.dayWidth ?? 24
  return (
    <div style={{ width: w, height: h, position: 'relative', borderBottom: '2px solid #cbd5e1', fontFamily: 'Inter, system-ui, sans-serif', pointerEvents: 'none', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', left: 0, top: 0, width: GANTT_LABEL_W, height: '100%', display: 'flex', alignItems: 'center', padding: '0 12px', fontSize: 13, fontWeight: 800, color: '#1e293b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {nodeData.label || 'Gantt'}
      </div>
      {ticks.map((t, i) => {
        const x = GANTT_LABEL_W + t.dayOffset * dayW
        return (
          <div key={i} style={{ position: 'absolute', left: x, top: 0, height: '100%' }}>
            <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 1, background: t.major ? '#cbd5e1' : '#eef2f6' }} />
            <div style={{ position: 'absolute', left: 4, bottom: 4, fontSize: 10, color: '#64748b', whiteSpace: 'nowrap' }}>{t.label}</div>
          </div>
        )
      })}
    </div>
  )
}

export default memo(GanttAxisNode)
